var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoubleLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.73066 8.00056L8.46994 1.9452C8.54316 1.85234 8.47709 1.71484 8.35744 1.71484H6.97709C6.88959 1.71484 6.80566 1.75592 6.75209 1.82377L2.19316 7.64877C2.1142 7.74938 2.07129 7.87357 2.07129 8.00145C2.07129 8.12934 2.1142 8.25353 2.19316 8.35413L6.75209 14.1773C6.80566 14.247 6.88959 14.2863 6.97709 14.2863H8.35744C8.47709 14.2863 8.54316 14.1488 8.46994 14.0559L3.73066 8.00056ZM9.15923 8.00056L13.8985 1.9452C13.9717 1.85234 13.9057 1.71484 13.786 1.71484H12.4057C12.3182 1.71484 12.2342 1.75592 12.1807 1.82377L7.62173 7.64877C7.54277 7.74938 7.49986 7.87357 7.49986 8.00145C7.49986 8.12934 7.54277 8.25353 7.62173 8.35413L12.1807 14.1773C12.2342 14.247 12.3182 14.2863 12.4057 14.2863H13.786C13.9057 14.2863 13.9717 14.1488 13.8985 14.0559L9.15923 8.00056Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleLeft);
export default __webpack_public_path__ + "static/media/double-left.4fb6f9f69ba70910414610f069fc5b97.svg";
export { ForwardRef as ReactComponent };